<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

import { authComputed } from '@state/helpers'
import { authProtectedRoutes } from '@routes'

/**
 * Application menu component
 */
export default {
  components: {},
  props: {
    mode: {
      type: String,
      default: 'horizontal',
    },
  },
  data() {
    return {
      menuItems: authProtectedRoutes,
    }
  },
  computed: {
    ...authComputed,
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = null
    this.filterRestrictedMenuItems()
    const isIntegrationCompany = this.isIntegrationCompany()

    if (isIntegrationCompany) {
      this.applyIntegrationCompanyMenu()
    } else if (this.isEmpresa169()) {
      this.applyEmpresa169Menu()
    } else if (this.$store.state.auth.currentUser.user === 'suporte') {
      let receituario = this.menuItems.findIndex(
        (menu) => menu.name == 'Receituário'
      )
      if (receituario > 0) this.menuItems.splice(receituario, 1)

      let ficha = this.menuItems.findIndex(
        (menu) => menu.name == 'Ficha Emergência'
      )
      if (ficha > 0) this.menuItems.splice(ficha, 1)

      let syngenta = this.menuItems.findIndex(
        (menu) => menu.name == 'Syngenta'
      )
      if (syngenta > 0) this.menuItems.splice(syngenta, 1)

      let estoque = this.menuItems.findIndex(
        (menu) => menu.name == 'Estoque'
      )
      if (estoque > 0) this.menuItems.splice(estoque, 1)

      let financeiro = this.menuItems.findIndex(
        (menu) => menu.name == 'Financeiro'
      )
      if (financeiro > 0) this.menuItems.splice(financeiro, 1)

      let integracoes = this.menuItems.findIndex(
        (menu) => menu.name == 'Integrações'
      )
      if (integracoes > 0) this.menuItems.splice(integracoes, 1)
    } else if (this.$store.state.auth.currentUser.user === 'agrimar') {
      let gerencial = this.menuItems.findIndex(
        (menu) => menu.name == 'Gerencial'
      )
      if (gerencial > 0) this.menuItems.splice(gerencial, 1)

      let cadastro = this.menuItems.findIndex(
        (menu) => menu.name == 'Receituário'
      )
      if (cadastro > 0) this.menuItems.splice(cadastro, 1)

      let syngenta = this.menuItems.findIndex(
        (menu) => menu.name == 'Syngenta'
      )
      if (syngenta > 0) this.menuItems.splice(syngenta, 1)

    } else if (this.$store.state.auth.currentUser.user === 'syngenta') {
      let gerencial = this.menuItems.findIndex(
        (menu) => menu.name == 'Gerencial'
      )
      if (gerencial > 0) this.menuItems.splice(gerencial, 1)
      let ficha = this.menuItems.findIndex(
        (menu) => menu.name == 'Ficha Emergência'
      )
      if (ficha > 0) this.menuItems.splice(ficha, 1)
      let financeiro = this.menuItems.findIndex(
        (menu) => menu.name == 'Financeiro'
      )
      if (financeiro > 0) this.menuItems.splice(financeiro, 1)
      let integracoes = this.menuItems.findIndex(
        (menu) => menu.name == 'Integrações'
      )
      if (integracoes > 0) this.menuItems.splice(integracoes, 1)

      let estoque = this.menuItems.findIndex(
        (menu) => menu.name == 'Estoque'
      )
      if (estoque > 0) this.menuItems.splice(estoque, 1)
    } else if (this.$store.state.auth.currentUser.user === 'admin_sistema') {
      let syngenta = this.menuItems.findIndex(
        (menu) => menu.name == 'Syngenta'
      )
      if (syngenta > 0) this.menuItems.splice(syngenta, 1)
    } else if (this.$store.state.auth.currentUser.user !== 'admin_sistema') {
      let ficha = this.menuItems.findIndex(
        (menu) => menu.name == 'Ficha Emergência'
      )
      if (ficha > 0) this.menuItems.splice(ficha, 1)

      let index = this.menuItems.findIndex((menu) => menu.name == 'Gerencial')
      if (index > 0) this.menuItems.splice(index, 1)

      let syngenta = this.menuItems.findIndex(
        (menu) => menu.name == 'Syngenta'
      )
      if (syngenta > 0) this.menuItems.splice(syngenta, 1)
    }
    let config = this.menuItems.findIndex((menu) => menu.name == 'Configurações')
    if (config > 0) this.menuItems.splice(config, 1)

    let treinamento = this.menuItems.findIndex((menu) => menu.name == 'Treinamentos')
    if (treinamento > 0) this.menuItems.splice(treinamento, 1)

    if (!isIntegrationCompany) {
      this.hideIntegrationCompanyMenu()
    }

    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on(
        'shown.metisMenu',
        function (event) {
          window.addEventListener('click', function menuClick(e) {
            if (!event.target.contains(e.target)) {
              menuRef.hide(event.detail.shownElement)
              window.removeEventListener('click', menuClick)
            }
          })
        }
      )
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    // let menuItemEl = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show'

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add(activeClass)
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.add(dropdownActiveClass)
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add(activeClass)
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add(dropdownActiveClass)
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add(activeClass)
      }
    }
  },
  methods: {
    filterRestrictedMenuItems() {
      const currentUser = this.$store.state.auth.currentUser
        ? this.$store.state.auth.currentUser.user
        : ''

      const canViewRestrictedItems =
        currentUser === 'agrotresestrelas' || currentUser === 'admin_sistema'

      this.menuItems = this.menuItems.filter((menu) => this.isMenuItemAllowedForUser(menu, currentUser)).map((menu) => {
        if (!Array.isArray(menu.children)) return menu

        return {
          ...menu,
          children: menu.children.filter(
            (child) =>
              (
                canViewRestrictedItems ||
                (child.name !== 'Logs SISDEV' && child.name !== 'Gestão de Receituários')
              ) &&
              this.isMenuItemAllowedForUser(child, currentUser) &&
              (currentUser !== 'syngenta' || menu.name !== 'Receituário' ||
                child.path === 'solicitacao-ra')
          ),
        }
      })
    },
    isMenuItemAllowedForUser(item, currentUser) {
      const allowedUsers =
        item && item.meta && Array.isArray(item.meta.allowedUsers)
          ? item.meta.allowedUsers
          : []

      if (!allowedUsers.length) return true

      const normalizedUser = String(currentUser || '').toLowerCase()
      return allowedUsers.map((user) => String(user).toLowerCase()).includes(normalizedUser)
    },
    getCurrentEmpresaId() {
      const user = this.$store && this.$store.state && this.$store.state.auth
        ? this.$store.state.auth.currentUser || {}
        : {}

      const idCandidates = [
        user.id_empresa_sistema,
        user.id_empresa,
        user.idEmpresa,
        user.empresa_id,
        user.idEmpresaSistema,
      ]

      for (let i = 0; i < idCandidates.length; i += 1) {
        const parsed = Number(idCandidates[i])
        if (!Number.isNaN(parsed) && parsed > 0) {
          return parsed
        }
      }

      return null
    },
    isEmpresa169() {
      if (window.localStorage.getItem('modo_demo_169') === '1') return true
      return this.getCurrentEmpresaId() === 169
    },
    applyEmpresa169Menu() {
      this.menuItems = this.menuItems.filter((menu) => menu.name === 'Dashboard')
    },
    isIntegrationCompany() {
      if (window.localStorage.getItem('modo_integracao_empresa') === '1') return true

      const user = this.$store && this.$store.state && this.$store.state.auth
        ? this.$store.state.auth.currentUser || {}
        : {}

      const booleanFlags = [
        user.empresa_integracao,
        user.integration_company,
        user.isIntegrationCompany,
      ]

      if (booleanFlags.some((item) => item === true || item === 'true' || item === 1)) {
        return true
      }

      const typeFields = [
        user.tipo_usuario,
        user.tipo_empresa,
        user.perfil,
        user.role,
        user.integracao,
        user.integration,
      ]

      if (typeFields.some((item) => String(item || '').toLowerCase().includes('integr'))) {
        return true
      }

      const nameFields = [
        user.user,
        user.login,
        user.username,
        user.nome_empresa,
        user.empresa,
      ]

      return nameFields.some((item) =>
        String(item || '')
          .toLowerCase()
          .includes('sankhya')
      )
    },
    applyIntegrationCompanyMenu() {
      this.menuItems = this.menuItems.filter((menu) => menu.name === 'Painel de Integração')
    },
    hideIntegrationCompanyMenu() {
      this.menuItems = this.menuItems.filter((menu) => menu.name !== 'Painel de Integração')
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item && item.children !== undefined
        ? item.children.length > 0
        : false
    },
    showsAsGroup(item) {
      return this.hasItems(item) && !item.landingPath
    },
  },
}
</script>

<template>
  <!--- Sidemenu -->

  <ul id="side-menu" class="metismenu">
    <li v-for="item in menuItems" :key="`item-${item.name}`" class="side-nav-title side-nav-item">
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <a v-if="showsAsGroup(item)" href="javascript:void(0);" class="side-nav-link">
        <feather v-if="item.icon" :type="item.icon"></feather>
        <span>{{ item.name }}</span>
        <span class="menu-arrow"></span>
      </a>

      <router-link
        v-if="!showsAsGroup(item)"
        tag="a"
        :to="item.landingPath || `${item.path}`"
        class="side-nav-link side-nav-link-ref"
      >
        <feather v-if="item.icon" :type="item.icon"></feather>
        <span>{{ item.name }}</span>
        <span v-if="item.badge" :class="
          'badge badge-' + item.badge.varient + ' float-right font-size-11'
        ">{{ item.badge.text }}</span>
      </router-link>

      <ul v-if="showsAsGroup(item)" class="nav-second-level">
        <li v-for="subitem in item.children" :key="`sub-item-${subitem.name}`"
          :class="{ 'side-nav-item': hasItems(subitem) }">
          <a v-if="hasItems(subitem)" href="javascript:void(0);" class="side-nav-link-a-ref">
            {{ subitem.name }}
            <span class="menu-arrow"></span>
          </a>

          <router-link v-if="!hasItems(subitem)" tag="a" :to="`${item.path}/${subitem.path}`"
            class="side-nav-link-ref">{{ subitem.name }}</router-link>

          <ul v-if="hasItems(subitem)" class="nav-third-level" aria-expanded="false">
            <li v-for="subSubitem in subitem.children" :key="`sub-sub-item-${subSubitem.name}`">
              <router-link tag="a" :to="`${item.path}/${subitem.path}/${subSubitem.path}`" class="side-nav-link-ref">{{
                subSubitem.name
              }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>

  <!-- End Sidebar -->
</template>
